module.exports = __webpack_public_path__ + "img/1920_contact.ee6e311f.png";